/**
 * Mirrors `common/models/NodeType.php` — IDs on tree nodes from `getTreeView` / `getHierarchyTree` (`model.typeId`).
 */
export const NodeTypeId = {
	NT_DISTRICT: 5,
	NT_SCHOOL: 6,
	NT_CLASS: 9,
	NT_SESSION: 12,
	NT_AREA: 13,
} as const;

/** True when `node.typeId` equals `typeId` (accepts string or number from JSON). */
export function nodeHasTypeId(node: any, typeId: number): boolean {
	const raw = node?.typeId;
	if (raw === null || raw === undefined) {
		return false;
	}
	return Number(raw) === typeId;
}
